var mobx = require("mobx");
export var makeObservable = "makeObservable" in mobx ? mobx["makeObservable"] : function(target) {
    return target;
};
